var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgConfirmedEnvelope(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.275 38.096L49.14 25.253a1 1 0 011.315 0 .96.96 0 010 1.359l-13.522 13.5a.928.928 0 01-.657.28.928.928 0 01-.657-.28l-5.024-5.016a.96.96 0 010-1.36c.33-.374.94-.374 1.315 0l4.366 4.36zm4.226 8.718c7.793 0 14.131-6.328 14.131-14.109 0-7.78-6.338-14.108-14.131-14.108-7.794 0-14.132 6.328-14.132 14.108 0 7.781 6.338 14.11 14.132 14.11z",
    fill: "#51D385"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.473 53.33l-11.315 9.702h-.047c-.047.094-.14.094-.188.14-.14.095-.281.095-.422.095a.885.885 0 01-.376-.094c-.094-.047-.14-.047-.234-.14L28.529 53.33 3.74 78.125h73.568L52.473 53.33zM2.38 76.766L27.122 52.11 11.018 38.377c-.047 0-.047 0-.047-.047L2.38 31.018v45.748zM28.857 10.488h23.334L40.5 2.098l-11.644 8.39zM70.36 23.518v12.093l7.7-6.562-7.7-5.53zM10.69 35.611V23.518l-7.7 5.531 7.7 6.563zM70.031 38.377L53.928 52.111l24.695 24.655V31.018l-8.592 7.359z",
    fill: "#FFA852"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.491 32.846c0-8.812 7.183-15.983 16.01-15.983 8.826 0 16.01 7.171 16.01 15.983 0 8.812-7.184 15.984-16.01 15.984-8.827 0-16.01-7.172-16.01-15.984zm-11.925 4.547L40.501 61.25l27.98-23.858v-24.89H12.567v24.89z",
    fill: "#223A32"
  })));
}

export default SvgConfirmedEnvelope;